import kr from 'Kr/kr';
import HTMLClass from '../../kr/utils/HTMLClass';

export default class IndividualImplementation extends kr.Component {
    init() {
        this.hoverEnabled = 993;
        this.slides = this.$element.querySelectorAll('.js-slider [data-slide]');
        this._prepare();

        this.slider = new Swiper(this.$element.querySelector('.js-slider'), {
            loop: false,
            slidesPerView: 1.2,
            centeredSlides: true,
            breakpoints: {
                993: {
                    slidesPerView: 3,
                    centeredSlides: false
                },
                767: {
                    slidesPerView: 2,
                    centeredSlides: true
                }
            }
        });   

        this._event();
    }
    
    _event() {
        this.on('mouseover', '.js-slider [data-slide]', (target, event) => {
            if (window.innerWidth < this.hoverEnabled) {
                return;
            }
            
            for (let slide of this.slides) {
                if (slide != target) {
                    this._unhover(slide);
                } else{
                    this._hover(target);
                }
            }
        });
    }

    _unhover(slide) {
        HTMLClass.removeClass(slide, 'slide--active');
        const text = this._getText(slide);
        if (text) {
            text.style.display = "none";
        }

        const img = this._getImg(slide);
        if (img) {
            img.src = img.getAttribute('data-src');
        }
    }
    _hover(slide) {
        HTMLClass.addClass(slide, 'slide--active');
        const text = this._getText(slide);
        if (text) {
            text.style.display = "block";
        }

        const img = this._getImg(slide);
        if (img) {
            img.src = img.getAttribute('data-src-hover');
        }
    }

    _getText(slide) {
        const dataSlide = slide.getAttribute('data-slide');
        return this.$element.querySelector(`[data-slide-texts] [data-slide="${dataSlide}"]`);
    }

    _getImg(slide) {
        const img = slide.querySelector('img[data-src-hover]');
        if (typeof img === 'undefined') {
            return null;;
        }
        return img;
    }

    _prepare()
    {
        const imgs = this.$element.querySelectorAll('.bs-section--irealisation__item img[data-src-hover]');
        for (let img of imgs) {
            img.setAttribute('data-src', img.src);
        }
    }
}

kr.registerComponent('.js-irealisation', {
    component: IndividualImplementation
});
